<template>
  <div>
     <b-button
      v-permission="'functionalities.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      :service="service"
      route_name="functionalities"
      order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('functionality.name') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('functionality.description') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="30%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="40%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'functionalities.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'functionalities.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import FunctionalityService from '@/services/api/FunctionalityService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/functionalities/create')
    }
  },
  beforeMount() {
    this.service = FunctionalityService.build(this.$vs)
  }
}
</script>
